import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const FETCH_STATS_REQUEST = "FETCH_STATS_REQUEST";
export const FETCH_STATS_SUCCESS = "FETCH_STATS_SUCCESS";
export const FETCH_STATS_FAILURE = "FETCH_STATS_FAILURE";

export const fetchStats = () => async (dispatch) => {
    dispatch({ type: FETCH_STATS_REQUEST });

    try {
        const response = await axios.get(`${BASE_URL}/v1/api/stats`, {
            headers: {
                authorization: `${localStorage.getItem('token')}`,
            }
        });

        dispatch({
            type: FETCH_STATS_SUCCESS,
            payload: response.data.data
        });
    } catch (error) {
        dispatch({
            type: FETCH_STATS_FAILURE,
            payload: error.message
        });
    }
};
